export default class SliderView extends Backbone.View {


    events() {
        return {
            "click .arrow-left": "slideRight",
            "click .arrow-right": "slideLeft"
        }
    }

    initialize(options) {
        this.single = options['single'];
        this.animation = options['animation'];
        this.keepNav = options['keepNav'];
        this.autoplay = options['autoplay'];
        this.pos = 0;
        this.interval = null;
        this.displayLimit = this.getDisplayLimit();
        this.getBoundings();
        $(window).resize(this.resize.bind(this));
        if (options['showBullits']) {
            this.showBullets();
        }
        this.initInterval();
    }

    initInterval() {
        this.interval = setInterval(this.autoSlide.bind(this), 15*1000);
    }

    autoSlide() {
        this.slideTo(this.pos + 1);
    }

    selectSlide(event) {
        event.preventDefault();
        this.slideTo(parseInt($(event.target).data("pos")));
    }

    showBullets() {
        for (var i = 0; i < this.length; i++) {
            var bullet = $('<a href="#" class="bullet"></a>');
            if (this.pos == i) {
                $(bullet).addClass("active");
            }
            $(bullet).data("pos", i);
            $(bullet).on("click", this.selectSlide.bind(this));
            $(bullet).appendTo(this.$el.find(".bullets"));
        }
    }

    resize() {
        let limit = this.getDisplayLimit();
        if (limit != this.displayLimit) {
            this.displayLimit = limit;
            this.getBoundings();
            this.slideTo(this.pos);
        }
    }

    getBoundings() {
        this.right = parseInt(this.$el.find(".slide-holder").css("right"));
        this.slideWidth = parseInt(this.$el.find(".slide-holder .slide:first").css("width"));
        this.slideMargin = parseInt(this.$el.find(".slide-holder .slide:first").css("margin-right"));
        this.length = this.$el.find(".slide-holder .slide").length;
        this.$slider = this.$el.find(".slide-holder");
        this.$slider.css("width", ((this.slideWidth + this.slideMargin) * this.length) + "px");
        if (!this.single) {
            this.slideTo(Math.ceil(this.length / 2) - 1);
        }
        this.$el.animate({"opacity": 1});
    }

    slideTo(index) {
        if (index > this.length - 1) {
            index = 0;
        } else if (index < 0) {
            index = this.length - 1;
        }
        this.$el.find(".bullet").removeClass("active");
        this.$el.find(`.bullets .bullet:eq(${index})`).addClass("active");
        this.$el.find(".slide").removeClass("active");
        this.$el.find(`.slide-holder .slide:eq(${index})`).addClass("active");

        this.pos = index;
        this.right = (this.slideWidth + this.slideMargin) * index;
        this.shift();
    }

    slideLeft(event) {
        event.preventDefault();
        this.slideTo(this.pos + 1);
    }

    slideRight(event) {
        event.preventDefault();
        this.slideTo(this.pos - 1);
    }

    getDisplayLimit() {
        if (this.single) {
            return 1;
        }
        let ww = $(window).width();
        if (ww > 768 && ww < 1279) {
            return 2;
        } else if (ww <= 767) {
            return 1;
        } else {
            return 3;
        }
    }

    shift() {
        if (this.pos == 0 && !this.keepNav) {
            this.$el.find(".arrow-left").animate({opacity: 0}, 300);
        } else {
            this.$el.find(".arrow-left").animate({opacity: 1}, 300);
        }
        if (this.pos + (this.displayLimit) >= this.length && !this.keepNav) {
            this.$el.find(".arrow-right").animate({opacity: 0}, 300);
        } else {
            this.$el.find(".arrow-right").animate({opacity: 1}, 300);
        }
        if (this.animation == "fade" && parseInt(this.$slider.css("right")) != this.right) {
            //this.$slider.fadeOut(function(){
            //    this.$slider.css("right", this.right + "px");
            //}.bind(this));
            //this.$slider.fadeIn();
        } else {
            this.$slider.css("right", this.right + "px");
        }
    }
}


// WEBPACK FOOTER //
// ./frontend/js/views/slider.js